import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  InfoBanner,
} from "@kanda-libs/ks-design-library";
import {
  PipelineColumn,
  SimpleCompanyCard,
} from "@kanda-libs/ks-design-library-new";
import { capitaliseWords } from "common/helpers";
import { URLS } from "components/shared/App/constants";
import PageTitle from "components/shared/PageTitle";
import type { FunctionComponent } from "react";
import { CLASS_NAMES } from "./constants";
import { getLeadName } from "./helpers";
import useLeadsPipeline from "./useLeadsPipeline";

const LeadsPipeline: FunctionComponent = function () {
  const { leadsByStatus, statuses } = useLeadsPipeline();
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContent>
        <PageTitle>Leads</PageTitle>
        <InfoBanner title="Leads Pipeline" />
        <div className={CLASS_NAMES.pipeline}>
          {statuses.map((status) => (
            <PipelineColumn
              key={`leads-${status}`}
              title={capitaliseWords(status.split("_").join(" "))}
            >
              {leadsByStatus[status].map((lead) => (
                <a
                  href={URLS.lead.replace(":id", lead?.id || "")}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  <SimpleCompanyCard
                    key={`leads-${status}-${lead?.id}`}
                    name={getLeadName(lead)}
                    signedUpDate={lead.metadata?.created_at || new Date()}
                  />
                </a>
              ))}
            </PipelineColumn>
          ))}
        </div>
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default LeadsPipeline;
